import { render } from "./accountSecurity.vue?vue&type=template&id=61f6b851&scoped=true"
import script from "./accountSecurity.vue?vue&type=script&lang=js"
export * from "./accountSecurity.vue?vue&type=script&lang=js"

import "./accountSecurity.vue?vue&type=style&index=0&id=61f6b851&lang=scss&scoped=true"
import "./accountSecurity.vue?vue&type=style&index=1&id=61f6b851&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f6b851"]])

export default __exports__